// import { cleanObject } from '@/helpers'
import { _toFixed } from '@/helpers/bigNumber'
import { apificateDate } from '@/helpers/formatDate'

export const getArray = state => {
  return state.list.map((key) => {
    return {
      ...state._[key],
      key,
      _showDetails: false
    }
  })
}

export const getElementByKey = state => (key) => {
  return {
    ...state._[key],
    key
  }
}

export const apificate = (state, getters) => {
  return state.list.map((key) => {
    let x = state._[key]
    let detail = {
      quantity: x.quantity,
      orderSender: x.orderSender,
      orderReceiver: x.orderReceiver,
      observation: x.observation,
      amount: _toFixed(x.amount, 2),
      discountsPercent: x.discountsPercent,
      totalDiscounts: _toFixed(x.totalDiscounts, 2),
      taxesPercent: x.taxesPercent,
      // totalTaxes: x.totalTaxes,
      amountBeforeTaxes: _toFixed(x.amountBeforeTaxes, 2),
      subtotal: _toFixed(x.subtotal, 2)
    }
    detail.product = {
      vendor: x.product.vendor,
      payer: x.product.payer,
      description: x.product.description,
      totalAmount: x.product.totalAmount,
      unit: x.product.unit,
      count: x.product.count
    }
    detail.discountsCharges = x.discountsCharges ? x.discountsCharges.map(k => Object.assign({}, k)) : null
    detail.taxes = x.taxes ? x.taxes.map(k => Object.assign({}, k)) : null
    detail.deliveryNotes = x.deliveryNotes ? x.deliveryNotes.map(k => Object.assign({}, k)) : null
    detail.inmobilizedData = x.inmobilizedData ? x.inmobilizedData.map(k => Object.assign({}, k)) : undefined
    detail.officeFinancialExpenses = x.officeFinancialExpenses ? x.officeFinancialExpenses.map(k => Object.assign({}, k)) : undefined
    detail.lineStartDate = x.itemStartDate !== undefined ? apificateDate(x.itemStartDate) : undefined
    detail.lineEndDate = x.itemEndDate !== undefined ? apificateDate(x.itemEndDate) : undefined
    return detail
  })
}
